import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { urlSlugLengthCheck } from "../../../pages/postEditor/seoAnalyzer/urlSlugHelper";

export default function UrlSlugCard({ analysis, content }) {
  const { t } = useTranslation();

  // Length of Content
  const length = useMemo(() => {
    return content?.url.full
      ? urlSlugLengthCheck(
          content.url.full.trim().length,
          analysis.url_slug.nb_words
        )?.percentage
      : 0;
  }, [analysis]);

  return analysis !== undefined && content !== undefined ? (
    <>
      <div className="py-3">
        {/* URL */}
        <div className="text-sm break-words">
          <label>
            <span className="text-black">
              {content?.url.protocol.trim()}://
              {content?.url.domain.trim()}
            </span>
            <span className="text-black">
              {content?.url.domain.trim().slice(-1) !== "/" ? "/" : ""}
            </span>
            <span className="text-blue-100 font-bold">
              {content?.url.path.trim()}
            </span>
            <span className="text-black">
              {content?.url.path.trim() ? "/" : ""}
            </span>
            <span className="text-blue-50 font-bold">
              {content?.url.slug.trim()}
            </span>
          </label>
        </div>

        <div className="break-words mt-2">
          {/* Target Request Included */}
          <div className="text-xs text-black  ">
            <span>
              {" "}
              {t("Target-request-included", "Target request included")}?{" "}
              <span
                className={`${
                  analysis?.url_slug.includes_seo_request == 2
                    ? "text-green-500"
                    : analysis?.url_slug.includes_seo_request == 1
                    ? "text-yellow-500"
                    : "text-red-600"
                }`}
              >
                {analysis?.url_slug.includes_seo_request == 2
                  ? t("Yes", "Yes")
                  : analysis?.url_slug.includes_seo_request == 1
                  ? t("Partially", "Partially")
                  : t("No", "No")}
              </span>
            </span>
          </div>

          {/* URL Length */}
          <div className="text-xs   text-black">
            <span>
              {" "}
              {t("Length", "Length")} :
              <span
                className={`${
                  length == 100
                    ? "text-green-500"
                    : length == 50
                    ? "text-yellow-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {analysis?.url_slug.nb_words} {t("word", "word")}
                {analysis?.url_slug.nb_words > 1 ? "s" : ""} ({" "}
                {analysis?.url_slug.nb_characters} {t("character", "character")}
                {analysis?.url_slug.nb_characters > 1 ? "s" : ""} )
              </span>
            </span>
          </div>

          {/* Special Characters  */}
          <div className="text-xs   text-black">
            <span>
              {" "}
              {t(
                "Special-Characters-other-than-hyphens",
                "Special character other than hyphens"
              )}
              ? :
              <span
                className={`${
                  analysis?.url_slug.includes_special_characters === false
                    ? "text-green-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {`${
                  analysis?.url_slug.includes_special_characters
                    ? t("Yes", "Yes")
                    : t("No", "No")
                }`}
              </span>
            </span>
          </div>

          {/* Part Depth */}
          <div className="text-xs   text-black">
            <span>
              {t("Path-Depth", "Path Depth")} :
              <span
                className={`${
                  analysis?.url_slug.path_depth >= 0 &&
                  analysis?.url_slug.path_depth <= 3
                    ? "text-green-500"
                    : analysis?.url_slug.path_depth == 4
                    ? "text-yellow-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {`${analysis?.url_slug.path_depth} ${t("part", "part")}${
                  analysis?.url_slug.path_depth > 1 ? "s" : ""
                }`}
              </span>
            </span>
          </div>

          {/* Lowercase */}
          <div className="text-xs   text-black">
            <span>
              {" "}
              {t("Lowercase", "Lowercase")} ?
              <span
                className={`${
                  analysis?.url_slug.is_only_lowercase
                    ? "text-green-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {`${
                  analysis?.url_slug.is_only_lowercase
                    ? t("Yes", "Yes")
                    : t("No", "No")
                }`}
              </span>
            </span>
          </div>
        </div>
      </div>
    </>
  ) : null;
}
